<template>
  <base-section
    id="clients"
  >
    <base-section-heading title="Nuestros Clientes">
      <!-- Lista de clientes recientes. -->
    </base-section-heading>

    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="(item, n) in items"
          :key="n"
          cols="12"
          md="3"
        >
          <base-img
            :src="require(`@/assets/${item.image}`)"
            color="grey"
            contain
            height="150"
            width="300"
          />
          <div class="text-center body-1 text-uppercase">
            {{ item.title }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionProChart',

    data: () => ({
      items: [
        {
          image: 'clients/logo-1.png',
          title: 'La Caixa',
        },
        {
          image: 'clients/logo-2.png',
          title: 'Iberdrola Inmobiliaria',
        },
        {
          image: 'clients/logo-3.png',
          title: 'Iberdrola Clientes',
        },
        {
          image: 'clients/logo-4.png',
          title: 'Novarquia',
        },
        {
          image: 'clients/logo-5.png',
          title: 'Mecadona',
        },
        {
          image: 'clients/logo-6.png',
          title: 'Cámara de Comercio Sevilla',
        },
        {
          image: 'clients/logo-7.png',
          title: 'Protecciones y Lacados',
        },
        {
          image: 'clients/logo-8.png',
          title: 'Galisur',
        },
        {
          image: 'clients/logo-9.png',
          title: 'Siplan',
        },
      ],
    }),
  }
</script>
